
import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import insightsImg from "../images/insights.jpeg"
import authorImg from "../images/author-sm.png"
import { database } from '../firebase';
import { Link } from "react-router-dom";
import $ from "jquery"
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
export default class Insights extends Component {
  constructor(props) {
    super(props)
    this.state = {
      storyData: [],
      storyCategories: [],
      storyDataBackUp: [],
      socialLinkKey: "",
      title: "Stories",
      storyCategoryData: []
    }
  }
  async componentDidMount() {
    let url_path = window.location.href.split("=");
    let keyId = url_path[1].replace("%20", " ")
    
    this.setState({
      title: keyId
    })
    let storyCategoryList = []
    await database.ref("storyCategory").once('value', function (snapshot) {
      snapshot.forEach(function (ChildSnapshot) {
        if (ChildSnapshot.val().status == 'Active' && keyId === ChildSnapshot.val().mainCategory) {
          storyCategoryList.push({
            key: ChildSnapshot.key,
            name: ChildSnapshot.val().name
          });
        }
      });
    });
    this.setState({
      storyCategoryData: storyCategoryList
    })
    this.renderList(keyId);
  }

  tgglBtnShare = (data) => {
    console.log("data...", data)
    this.setState({
      socialLinkKey: data.key
    })
    $(".toggle-button-i").toggleClass("fa-share-alt")
    $(".toggle-button-i").toggleClass("fa-times-circle-o")
    $(".social-share-ul").toggleClass("social-share-ul-visible")
  }

  async renderList(keyId) {
    let dataList = []
    let dataListCategory = []
    await database.ref("stories").once('value', function (snapshot) {
      snapshot.forEach(
        function (ChildSnapshot) {
          if (ChildSnapshot.val().status == 'Active' && keyId == ChildSnapshot.val().mainCategory) {
            dataList.push({
              key: ChildSnapshot.key,
              storyTitle: ChildSnapshot.val().title,
              storyImage: ChildSnapshot.val().imageUrl,
              storyStatus: ChildSnapshot.val().status,
              storyDescription: ChildSnapshot.val().description,
              shortDescription: ChildSnapshot.val().shortDescription,
              storyCategory: ChildSnapshot.val().category,
              createdAt: ChildSnapshot.val().createdAt,
              fbLink: "https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fivanooo.com%2F'" + ChildSnapshot.val().title + "'%2F",
              twitterLink: "https://twitter.com/intent/tweet/?text=The+Importance+of+Planning+Your+Career&amp;url=https%3A%2F%2Fivanooo.com%2F'" + ChildSnapshot.val().title + "'%2F"
            })
            dataListCategory.push({
              storyCategory: ChildSnapshot.val().category
            })
          }
        }
      )
    })
    const results = dataList.filter(({ storyCategory: id1 }) => this.state.storyCategoryData.some(({ name: id2 }) => id2 === id1));
    
    this.setState({
      storyData: results,
      storyDataBackUp: results,
      storyCategories: dataListCategory
    })
  }
  filterByCategory = (text, id) => {
    $(".insights-tab-span").removeClass("insights-tab-span-act")
    $("#" + id).addClass("insights-tab-span-act")
    if (text == "all") {
      this.setState({
        storyData: this.state.storyDataBackUp,
      });
    }
    else {
      const newData = this.state.storyDataBackUp.filter(item => {
        const itemData = `${item.storyCategory.toUpperCase()} ${item.storyCategory.toUpperCase()} ${item.storyCategory.toUpperCase()}`;
        const textData = text.toUpperCase();
        return itemData.indexOf(textData) > -1;
      });
      this.setState({
        storyData: newData,
      });
    }

  }
  render() {
    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content px-0">
          <section className="Insights-wrapper">
            <div className="">
              <div className='insights-tab'>
                <span id='all' className='insights-tab-span insights-tab-span-act' style={{ cursor: 'pointer' }} onClick={() => this.filterByCategory("all", "all")}>All </span>

                {
                  this.state.storyCategoryData.slice(0, 5).map((x, y) =>
                    <span id={x.name.replace(/ /g, '')} className='insights-tab-span' style={{ cursor: 'pointer' }} onClick={() => this.filterByCategory(x.name, x.name.replace(/ /g, ''))}>{x.name}</span>
                  )
                }
              </div>
              <section className="page-header">
                <div className="container iavno-works-head text-center">
                  <h4>{this.state.title}</h4>
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb justify-content-center mb-0">
                      <li className="breadcrumb-item"><a href="#">Home</a></li>
                      <li className="breadcrumb-item active" aria-current="page">{this.state.title}</li>
                    </ol>
                  </nav>
                </div>
              </section>
              <div className="container">
                <div className="row">
                  <div className="insights-body col-lg-12">
                    {this.state.storyData.map((data, i) => {
                      return (
                        <div className="insights-box">
                          <div className="tag-learning">
                            <i className="fa fa-tags"></i> {data.storyCategory}
                          </div>
                          {/* <Link to={{
                              pathname: '/insights-details',
                              state: {
                                storyCategory: data.storyCategory,
                                storyImage: data.storyImage,
                                storyTitle: data.storyTitle,
                                storyDescription: data.storyDescription,
                                storyCategories:this.state.storyCategories,
                                shortDescription:this.state.shortDescription,
                                createdAt:data.createdAt
                              }
                            }}> */}
                          <Link to={'/insights-details/id=' + data.key + "~" + data.storyTitle+"~"+this.state.title} params={data.key}>
                            <div className="insights-img-div">
                              <img alt="" className="insights-img" src={data.storyImage} />
                            </div>
                          </Link>
                          <ul className="insights-box-list">
                            {/* <li className="insights-list-inline-item">
                                <img src={authorImg} className="authorImg" alt="author" />Katen Doe
                              </li> */}
                            <li className="insights-list-inline-item">{data.createdAt}</li>
                          </ul>
                          <Link to={'/insights-details/id=' + data.key + "~" + data.storyTitle+"~"+this.state.title}>
                            <div className="insights-box-text">{data.storyTitle}</div>
                            <p className="insights-box-subtext">{ReactHtmlParser((data.shortDescription).substring(0, 200))}</p>
                            {/* <a href="/insights-details" className="btn insights-box-a">Read Now</a> */}
                          </Link>
                          <div className='insights-box-social-share'>
                            <div className="social-share">
                              <span className='toggle-button-share'>
                                <i className="toggle-button-i fa fa-share-alt" onClick={() => this.tgglBtnShare(data)} aria-hidden="true"></i>
                              </span>
                              {data.key == this.state.socialLinkKey &&
                                <ul className="social-share-ul">
                                  <li className="social-share-list">
                                    <a target="_blank" href={data.fbLink}><i className="fa fa-facebook-f"></i></a>
                                  </li>
                                  <li className="social-share-list">
                                    <a href={data.twitterLink}><i className="fa fa-twitter"></i></a>
                                  </li>
                                  <li className="social-share-list">
                                    <a href="#"><i className="fa fa-linkedin"></i></a>
                                  </li>
                                  <li className="social-share-list">
                                    <a href="#"><i className="fa fa-pinterest"></i></a>
                                  </li>
                                  <li className="social-share-list">
                                    <a href="#"><i className="fa fa-paper-plane"></i></a>
                                  </li>
                                  <li className="social-share-list">
                                    <a href="#"><i className="fa fa-envelope"></i></a>
                                  </li>
                                </ul>
                              }
                            </div>
                            <Link to={'/insights-details/id=' + data.key + "~" + data.storyTitle+"~"+this.state.title} className="insights-box-a">
                              <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
                            </Link>
                          </div>
                        </div>
                      )
                    })}
                    {/* <div>
                      <nav aria-label="Page navigation example pl-3">
                        <ul className="pagination justify-content-end">
                          <li className="page-item"><a className="page-link page-number-det">Page 1 of 18</a></li>
                          <li className="page-item">
                            <a className="page-link" href="#" aria-label="Previous">
                              <span aria-hidden="true">&laquo;</span>
                              <span className="sr-only">Previous</span>
                            </a>
                          </li>
                          <li className="page-item page-item-act"><a className="page-link" href="#">1</a></li>
                          <li className="page-item"><a className="page-link" href="#">2</a></li>
                          <li className="page-item"><a className="page-link" href="#">3</a></li>
                          <li className="page-item">
                            <a className="page-link" href="#" aria-label="Next">
                              <span aria-hidden="true">&raquo;</span>
                              <span className="sr-only">Next</span>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div> */}
                  </div>

                  {/* <div className='col-lg-3 mt-4'>
                    <div className="form-head">Search</div>
                    <div className='col-lg-12 col-md-6 form-group' style={{ position: "relative" }}>
                      <input type="text" className="form-control" placeholder="Search..." />
                      <svg className="svg-icon search-icon" aria-hidden="true" role="img" focusable="false" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.80758 0C3.95121 0 0 3.95121 0 8.80758C0 13.6642 3.95121 17.6152 8.80758 17.6152C13.6642 17.6152 17.6152 13.6642 17.6152 8.80758C17.6152 3.95121 13.6642 0 8.80758 0ZM8.80758 15.9892C4.8477 15.9892 1.62602 12.7675 1.62602 8.80762C1.62602 4.84773 4.8477 1.62602 8.80758 1.62602C12.7675 1.62602 15.9891 4.8477 15.9891 8.80758C15.9891 12.7675 12.7675 15.9892 8.80758 15.9892Z" fill="currentColor"></path><path d="M19.762 18.6121L15.1007 13.9509C14.7831 13.6332 14.2687 13.6332 13.9511 13.9509C13.6335 14.2682 13.6335 14.7831 13.9511 15.1005L18.6124 19.7617C18.7712 19.9205 18.9791 19.9999 19.1872 19.9999C19.395 19.9999 19.6032 19.9205 19.762 19.7617C20.0796 19.4444 20.0796 18.9295 19.762 18.6121Z" fill="currentColor"></path></svg>
                    </div>
                    <div className='col-md-12 mt-5'>
                      <div className="form-head">Categories</div>
                      <div className='col-md-12 p-0'>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("all")}>All</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("Career Story")}>Career Story</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("Conversational Marketing")}>Conversational Marketing</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("Cybersecurity")}>Cybersecurity</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("Data Science")}>Data Science</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("Digital Marketing")}>Digital Marketing</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("Experiment")}>Experiment</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("Growth Marketing")}>Growth Marketing</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("How to become")}>How to become</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("Learning")}>Learning</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("Robotics Engineer")}>Robotics Engineer</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("SEO")}>SEO</a>
                      </div>
                      <div className='Categories-list'>
                        <i className="fa fa-tag"></i>
                        <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory("Uncategorized")}>Uncategorized</a>
                      </div>

                        {/* {this.state.storyCategories.map((data, i) => {
                          return (
                            <div className='Categories-list'>
                              <i className="fa fa-tag"></i>

                              <a style={{paddingLeft: '5px',color: '#337AB7',fontFamily: 'poppins'}} onClick={() => this.filterByCategory(data.storyCategory)}>{data.storyCategory}</a>

                            </div>
                          )
                        })} */}
                  {/* </div>
                    </div>
                  </div> */}
                </div>

              </div>
            </div>
          </section>
        </div>
        <Footer></Footer>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/ivano/insights.jsx